import '../css/app.scss';
import './script/neto.js';
import { addEvent, appHeight } from './script/utils';
import sliders from './script/slider';
import mobMenu from './script/mobMenu';
import readMore from './script/readmore';
import accordian from './script/accordian';
import headerPopups from './script/headerPopups';
import megamenu from './script/megamenuPos';
import stickyHeader from './script/stickyHeader';
import showHideFilters from './script/showHidefilters';
import showHideProducts from './script/showHideProducts';
import cartLine from './script/cartLine';
import scrollMenu from './script/scrollMenu';
import stickySidebar from './script/stickySidebar';
import thumbHeight from './script/thumbHeight';
import './script/popupCalls';
addEvent();
appHeight();

sliders.init();
mobMenu.init();
readMore.init();
accordian.init();
headerPopups.init();
megamenu.init();
stickyHeader.init();
showHideFilters.init();
showHideProducts.init();
cartLine.init();
scrollMenu.init();
thumbHeight.init();
stickySidebar.init();
